
export default (key) => ({
  key,
  href: null,
  isValid: false,

  // (De)activates the button and sets it's href with interpolated values.
  toggleActive(isValid) {
    this.href = this.urlWithVars()
    this.isValid = isValid
  },

  // Adds the user input vars query param to the current URL.
  urlWithVars() {
    const url = new URL(location.href)
    const oldVars = safelyParseVarsJson(url.searchParams.get('vars')) || {}
    const newVars = Object.assign(oldVars, this.dimensions())
    const newChoices = new Set(url.searchParams.get('choices').split('/'))
    newChoices.add(this.key)
    url.searchParams.set('vars', JSON.stringify(newVars))
    url.searchParams.set('choices', Array.from(newChoices).join('/'))
    return url.toString()
  },

  // Builds an object with the user's chosen dimensions.
  dimensions() {
    return {
      width: this.$refs.width.value,
      height: this.$refs.height.value,
    }
  },
})

// Tries to parse the vars JSON value and returns an empty object on failure.
function safelyParseVarsJson(json) {
  try {
    return JSON.parse(json)
  } catch (e) {}
}
